/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Button, Row, Col, DatePicker, Select, Table, Upload, message, Icon } from 'antd';
import moment from 'moment';
import { DmsTab, SelectRange, UploadFile } from 'Components';
import { openNotice, APIS } from 'Utils';
import ProductModal from '../inventory/productModal';
import { recoverCreate, secondClientList } from '../../service/financialMgm';
const FormItem = Form.Item;

class ReceivedPaymentAdd extends React.Component {
  
  constructor (props) {
    super(props);
    this.state = {
      opts: ['回款'],
      btnLoad: false,
      detail: {
        productId: '',
        price: ''
      },
      endOpen: false, // 控制失效时间选择
      promotionActivityType: [
          {key: 0, sKey: '对公转账', name: '对公转账'},
          {key: 1, sKey: '现金', name: '现金'},
          {key: 2, sKey: '支票', name: '支票'},
          {key: 3, sKey: '支付宝', name: '支付宝'},
          {key: 4, sKey: '微信', name: '微信'},
          {key: 5, sKey: '其他', name: '其他'}
      ],
      clientList: [],
      informationProps: { // 上传附件
        name: 'file',
        action: APIS.upload,
        headers: {
          authorization: 'authorization-text',
        },
        data: {
          id: '-5',
          dealType: '5'
        },
        onChange: this.updateInformation.bind(this),
      },
      searchObj:{
        p:1,
        s:1000
      },
      informationLi: []  // 已上传的附件 List
    }
    // this.addSubmit = this.addSubmit.bind(this);
  }

  /*上传附件*/
  updateInformation(result) {
    let informationLi = this.state.informationLi || [];
    // informationLi = informationLi.slice(0);    //控制上传数量
    if (result.file.status === 'done') {
      let responseData = result.file.response || {};
      if (responseData.code != 200) {
        openNotice('error', '附件上传失败');
        return;
      }
      informationLi.push({
        id: responseData.data.id,
        fileName: responseData.data.fileName,
      });
    }
    this.setState({
      informationLi: informationLi
    })
  };

  goBack = () => {
    hashHistory.goBack();
  };
  /* 提交 */
  addSubmit () {
    // console.log(this);
    const {validateFields, getFieldsValue, /* getFieldValue*/} = this.props.form;
    const informationLi = this.state.informationLi;
    this.props.form.validateFields((err, fieldsValue) => {
      if (!err) {
        // console.log('Received values of form: ', values);
        const values = {
          ...fieldsValue,
          recoverDate: fieldsValue.recoverDate ? fieldsValue.recoverDate.format('YYYY-MM-DD HH:mm:ss') : ''
        }
        // console.log(values);
        // console.log(informationLi);
        let attachmentDto = informationLi.map(x => {
            return { attachId: x.id }
          })
        // console.log(attachmentDto);
        let _params = {...values, attachmentDto};
        // console.log(_params);
        // return
        recoverCreate(_params).then(result => {
          openNotice('success', '新增成功', '');
          this.goBack();
        });
      } else {
        console.log('Error Messages: ', err);
        return
      }
    });
    /*this.props.form.getFieldsValue((err, values) => {
      if (!err) {
        console.log('get values of form: ', values);
      }
    });*/
    // const data = {
    //   ...getFieldsValue() //获取用户输入
    // };
    // // data.recoverDate = data.recoverDate.format('YYYY-MM-DD HH:mm:ss');
    // console.log(data);
  };

  disabledStartDate = (startValue) => {
  }
  disabledEndDate = (endValue) => {
  }
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  }
  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  }

  /*获取列表数据*/
  initData () {
    var obj = this.state.searchObj;
    secondClientList(obj).then(result => {  // 获取客户列表
      // console.log(result);
      if (result.status) {
        this.setState({
          clientList: result.data
        })
      } else {
        message.error(result.message);
      }
    })
  }

  componentDidMount () {
  this.initData();
  //设置离开当前路由时的钩子函数
  // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  render () {
    const { opts, detail, promotionActivityType, btnLoad, endOpen, clientList, informationProps } = this.state;
    const {getFieldDecorator} = this.props.form;
    const props = {
      name: 'file',
      action: '//jsonplaceholder.typicode.com/posts/',
      headers: {
        authorization: 'authorization-text',
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
    };
    let self = this;
    const inputWidth = {
      width: 300
    };
    const mt = {
        marginTop:10
    };
    const formItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
    };
    // <Col className="gutter-row" span={12}>
    //     <label>收款编号：2016053100001</label>
    // </Col>
    return <div>
      <DmsTab options={opts} defaultKey={0}>
        <Button type='primary' htmlType="submit" loading={btnLoad} onClick={this.addSubmit.bind(this)}>提交</Button>
        <Button onClick={this.goBack}>取消</Button>
      </DmsTab>
      <div className="dms-table-box">
        <Form layout="horizontal" onSubmit={this.addSubmit}>
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <FormItem {...formItemLayout} label="收款日期：">
                {getFieldDecorator('recoverDate', {
                  rules: [
                    {
                      required: true,
                      message: '收款日期：'
                    }
                  ],
                })(<DatePicker
                    showTime={false}
                    disabled={detail.id ? true : false}
                    onOpenChange={this.handleStartOpenChange}
                    disabledDate={this.disabledStartDate}
                    format="YYYY-MM-DD HH:mm:ss" style={inputWidth} />)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12} id="clientId">
              <FormItem {...formItemLayout} label="客户名称" hasFeedback>
                {getFieldDecorator('cusId', {
                  rules: [
                    {
                      required: true,
                      message: '请选择客户名称'
                    }
                  ],
                })(<Select
                  showSearch
                  allowClear
                  multiple={false}
                  disabled={detail.id ? true : false}
                  style={{ width: '300px' }}
                  placeholder="请选择客户名称"
                  optionFilterProp="desc"
                  getPopupContainer={() => document.getElementById('clientId')}
                  >
                    {
                      clientList.map((item, key) => {
                        return (
                            <Select.Option key={key + ''} value={item.id + ''} desc={item.name}>{item.name}</Select.Option>
                        )                       
                      })
                    }
                </Select>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16} style={mt}>
            <Col className="gutter-row" span={12} id="classifyId">
              <FormItem {...formItemLayout} label="收款方式">
                {getFieldDecorator('recoverType', {
                  initialValue: (detail !== null && detail.recoverType) ? detail.recoverType : '',
                  rules: [
                    {
                      required: true,
                      message: '请选择收款方式'
                    }
                  ],
                })(<Select
                  showSearch
                  allowClear
                  multiple={false}
                  disabled={detail.id ? true : false}
                  style={{ width: '300px' }}
                  placeholder="请选择收款方式"
                  optionFilterProp="desc"
                  getPopupContainer={() => document.getElementById('classifyId')}
                  >
                    {
                      promotionActivityType.map((item, key) => {
                        return (
                            <Select.Option key={key + ''} value={item.sKey + ''} desc={item.name}>{item.name}</Select.Option>
                        )                       
                      })
                    }
                </Select>)}
              </FormItem>
            </Col>
            <Col className="gutter-row" span={12}>
              <FormItem {...formItemLayout} label="收款金额：" hasFeedback>
                {getFieldDecorator('recoverCount', {
                  initialValue: (detail !== null && detail.recoverCount) ? detail.recoverCount : '',
                  rules: [
                    {
                      required: true,
                      message: '请输入收款金额'
                    }
                  ],
                })(<Input placeholder="请输入收款金额" type="text" style={inputWidth}/>)}
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16} style={mt}>
            <Col className="gutter-row" span={22}>
              <FormItem label="备注：">
                {getFieldDecorator('remark', {
                  initialValue: (detail !== null && detail.remark) ? detail.remark : '',
                  rules: [
                    {
                      required: false,
                      message: '请输入备注'
                    }
                  ],
                })(<Input.TextArea />)}
              </FormItem>              
            </Col>
          </Row>
          <Row gutter={16} style={mt}>
            <Col className="gutter-row">
              <label>收款凭证：</label>
              {
              <Upload {...informationProps}>
                  <Button>
                    <Icon type="upload" /> 上传
                </Button>
              </Upload>
              // <DmsTab className="white-bg no-border" options={['附件']} defaultKey={0}>
              // </DmsTab>
              // <UploadFile color="red"
              //   entityType="payment"
              //   entityId={'linkmanId'}
              //   onSuccess={this.getFiles}/>
              }
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  }
};
// export default ReceivedPaymentAdd;
export default Form.create()(ReceivedPaymentAdd);


// WEBPACK FOOTER //
// ./src/routes/financialMgm/receivedPaymentAdd.js